'use client';

import cx from 'classnames';
import { useReducedMotion } from 'framer-motion';

import { type Masked } from '~/contentful/graphql';
import footerStyles from '~/ui/modules/layout/footer/footer.module.scss';
import typographyStyles from '~/ui/styles/typography.module.scss';
import { useHasCursor } from '~/ui/utils/use-has-cursor';

import { type Ideas_QueryFragment } from './query';
import { AnimatedIdeas, StaticIdeas } from './variants';

export interface IdeasProps {
  data: Masked<typeof Ideas_QueryFragment>;
}

export function Ideas({ data }: IdeasProps) {
  const prefersReducedMotion = useReducedMotion();
  const hasCursor = useHasCursor();

  return (
    <nav>
      <div className={cx(typographyStyles.bodyLarge, footerStyles.title)}>Explore Ideas</div>
      {hasCursor && !prefersReducedMotion ? (
        <AnimatedIdeas ideas={data} />
      ) : (
        <StaticIdeas ideas={data} />
      )}
    </nav>
  );
}
